import ApiService from './api.service';

class AuthenticationError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const os = require('os');
const RESOURCE = 'licencia';

const LicenciaService = {

    getMacAddress(){
        /* obtener la dirección mac de la máquina */
        let type = os.type();
        let mac = null;
        let interfaces_list = [];
        switch (type) {
            case 'Linux':
                interfaces_list = ['eno0', 'eno1', 'eno2', 'eno3', 'eno4', 'eno5','enp4s0'];
                break;
            case 'Darwin':
                interfaces_list = ['en0', 'en1', 'en2', 'en3', 'en4', 'en5'];
                break;
            case 'Windows_NT':
                interfaces_list = ['eth0', 'eth1', 'eth2', 'eth3', 'eth4', 'eth5'];
                break;
        }

        let interfaces = os.networkInterfaces();
        console.log(interfaces);

        for (let i = 0; i < interfaces_list.length; i++) {
            let match = interfaces[interfaces_list[i]];
            if (match != undefined) {
                mac = match[0]['mac'];
            }
        }
        return mac;
    },
    
    getSearchMatchMacAddress: async function () {
        let mac = this.getMacAddress();
        const requestData = {
            method: 'post',
            url: `/${RESOURCE}/searchmac/`,
            data: {
                macAddress: mac
            }
        }

        try {
            const response = await ApiService.customRequest(requestData)
            //ApiService.setHeader()
            ApiService.mount401Interceptor();
            return response.data;

        } catch (error) {
            console.log(error.response);
            if(error.response.status == 404){
                return false;
            }
            if (error.response.status == 500){
                throw new AuthenticationError(error.response.status, error.response.data.detail)
            }            
        }
    },

    validateMatchClave: async function (data) {
        const requestData = {
            method: 'post',
            url: `/${RESOURCE}/match/`,
            data: data
        }

        try {
            const response = await ApiService.customRequest(requestData)
            //ApiService.setHeader()
            ApiService.mount401Interceptor();
            return response.data;

        } catch (error) {
            if (error.response.status == 404) {
                return false;
            }
            if (error.response.status == 500) {
                throw new AuthenticationError(error.response.status, error.response.data.detail)
            }
        }
    },

    clave: async function (data){
        const requestData = {
            method: 'post',
            url: `/${RESOURCE}/availableC/`,
            data: {
                id: data
            }
        }
        try {
            const response = await ApiService.customRequest(requestData)
            //ApiService.setHeader()
            ApiService.mount401Interceptor();
            return response.data;
        } catch (error) {
            if (error.response.status == 404) {
                return false;
            }
            if (error.response.status == 500) {
                throw new AuthenticationError(error.response.status, error.response.data.detail)
            }
        }//verificar si se manda el valor de user
        
    },

    updateLicencia: async function (data){
        try {
            const response = await ApiService.put(RESOURCE,data);
            ApiService.setHeader()
            ApiService.mount401Interceptor();
            return response.data;
        } catch (error) {
            if (error.response.status == 500) {
                throw new AuthenticationError(error.response.status, error.response.data.detail)
            }
        }
    }
};

export default LicenciaService;
export { LicenciaService };